<template>
  <div class="is-half-width">
    <h2 class="is-size-3 has-text-centered has-text-weight-medium m-b-10">
      {{ title }}
    </h2>
    <div
      class="has-background-secondary has-text-centered has-border-radius py-2 is-size-2 has-text-weight-semibold"
    >
      <slot name="value" />
    </div>
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinalTaxesResultItem',
  slotsDefinition: {
    value: {}
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>
